import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "23",
  viewBox: "0 0 26 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.92857 7.04159L4.41931 20.4583H21.5809L23.0716 7.04159H2.92857ZM1.76951 4.886C2.03166 4.76882 2.31557 4.70825 2.6027 4.70825H23.3975C23.6846 4.70825 23.9685 4.76882 24.2307 4.886C24.4928 5.00318 24.7273 5.17433 24.9188 5.38829C25.1103 5.60224 25.2545 5.85419 25.342 6.12766C25.4295 6.40113 25.4584 6.68999 25.4267 6.97538L23.8711 20.9754C23.8156 21.4748 23.578 21.9361 23.2036 22.2712C22.8292 22.6063 22.3444 22.7916 21.8419 22.7916H4.15826C3.65582 22.7916 3.17101 22.6063 2.79663 22.2712C2.42224 21.9361 2.18456 21.4748 2.12908 20.9754L0.573523 6.97538L1.73286 6.84657L0.573523 6.97538C0.541814 6.69 0.570658 6.40114 0.658172 6.12766C0.745685 5.85418 0.8899 5.60224 1.0814 5.38829C1.2729 5.17433 1.50737 5.00318 1.76951 4.886Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.0002 2.66659C12.1493 2.66659 11.3332 3.00461 10.7315 3.60628C10.1298 4.20796 9.79183 5.02402 9.79183 5.87492C9.79183 6.51925 9.26949 7.04159 8.62516 7.04159C7.98083 7.04159 7.4585 6.51925 7.4585 5.87492C7.4585 4.40518 8.04235 2.99563 9.08161 1.95637C10.1209 0.917104 11.5304 0.333252 13.0002 0.333252C14.4699 0.333252 15.8794 0.917104 16.9187 1.95637C17.958 2.99563 18.5418 4.40518 18.5418 5.87492C18.5418 6.51925 18.0195 7.04159 17.3752 7.04159C16.7308 7.04159 16.2085 6.51925 16.2085 5.87492C16.2085 5.02402 15.8705 4.20796 15.2688 3.60628C14.6671 3.00461 13.8511 2.66659 13.0002 2.66659Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }